// axios
import axios from 'axios'

// const baseURL = 'http://localhost:3000'
const baseURL = process.env.VUE_APP_API_URL || 'https://api.laosetthi.com'

export default axios.create({
  baseURL: baseURL
})
